import ArrowIcon from "../Logos/Arrow";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import { useSelector,useDispatch } from "react-redux";

const CTA = ({ text, link, handleClick, sizeClass = null, isSuperbrandHeroPresent = false,lightText=false,isHover,noPWALoader }) => {
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const dispatch = useDispatch();
  const handlePWAClick = (e) => {
    if(isPWA && !noPWALoader) {
      dispatch(showPwaLoader(true))
    }
  }
  return (
    text && (
      <a tabIndex={0} href={link} className={`cta no-border ${sizeClass?sizeClass:"normal"}`} onClick={(e) => 
        {
          handlePWAClick()
          handleClick?handleClick():""
       }
       } >
        {isHover?<span className="hover">{text}</span>:<div>{text}</div>}
        <span className="cta-arrow">
            <ArrowIcon height="10" width="15" stroke={isSuperbrandHeroPresent || lightText?"#ffffff":"#2f2f30"}/>
        </span>
      </a>
    )
  );
};

export default CTA;
